import { categoryAddUrl } from "@dashboard/categories/urls";
import SearchInput from "@dashboard/components/AppLayout/ListFilters/components/SearchInput";
import { BulkDeleteButton } from "@dashboard/components/BulkDeleteButton";
import { DashboardCard } from "@dashboard/components/Card";
import { InternalLink } from "@dashboard/components/InternalLink";
import { CategoryDetailsQuery } from "@dashboard/graphql";
import { ListProps, ListViews, RelayToFlat } from "@dashboard/types";
import { Box, Button } from "@saleor/macaw-ui-next";
import React from "react";
import { FormattedMessage, useIntl } from "react-intl";

import { CategoryListDatagrid } from "../CategoryListDatagrid";

interface CategorySubcategoriesProps
  extends Pick<ListProps<ListViews.CATEGORY_LIST>, "onUpdateListSettings" | "settings"> {
  categoryId: string;
  disabled: boolean;
  subcategories: RelayToFlat<NonNullable<CategoryDetailsQuery["category"]>["children"]>;
  initialSearch?: string;
  onSearchChange?: (query: string) => void;
  onCategoriesDelete: () => void;
  onSelectCategoriesIds: (ids: number[], clearSelection: () => void) => void;
}

export const CategorySubcategories = ({
  categoryId,
  subcategories,
  disabled,
  initialSearch = "",
  onSearchChange,
  onCategoriesDelete,
  onSelectCategoriesIds,
  settings,
  onUpdateListSettings,
}: CategorySubcategoriesProps) => {
  const intl = useIntl();

  return (
    <DashboardCard>
      <DashboardCard.Header>
        <DashboardCard.Title>
          <FormattedMessage
            id="NivJal"
            defaultMessage="All Subcategories"
            description="section header"
          />
        </DashboardCard.Title>
        <DashboardCard.Toolbar>
          <InternalLink to={categoryAddUrl(categoryId)}>
            <Button variant="secondary" data-test-id="create-subcategory">
              <FormattedMessage
                id="UycVMp"
                defaultMessage="Create subcategory"
                description="button"
              />
            </Button>
          </InternalLink>
        </DashboardCard.Toolbar>
      </DashboardCard.Header>

      {onSearchChange && (
        <Box paddingX={6} marginBottom={2}>
          <Box __width="320px">
            <SearchInput
              initialSearch={initialSearch}
              placeholder={intl.formatMessage({
                id: 'YWBXxG',
                defaultMessage: "Search subcategories...",
              })}
              onSearchChange={onSearchChange}
            />
          </Box>
        </Box>
      )}

      <CategoryListDatagrid
        settings={settings}
        onUpdateListSettings={onUpdateListSettings}
        categories={subcategories || []}
        disabled={disabled}
        onSelectCategoriesIds={onSelectCategoriesIds}
        selectionActionButton={
          <Box paddingRight={5}>
            <BulkDeleteButton onClick={onCategoriesDelete}>
              <FormattedMessage defaultMessage="Delete categories" id="FiO/W/" />
            </BulkDeleteButton>
          </Box>
        }
      />
    </DashboardCard>
  );
};
